export const QUOTES_RESET_STATE = 'QUOTES_RESET_STATE';
export const QUOTES_CURRENT_ITEM = 'QUOTES_CURRENT_ITEM';

export const QUOTES_REQUEST_LOADING = 'QUOTES_REQUEST_LOADING';
export const QUOTES_REQUEST_SUCCESS = 'QUOTES_REQUEST_SUCCESS';
export const QUOTES_REQUEST_FAILED = 'QUOTES_REQUEST_FAILED';

export const QUOTES_CURRENT_ACTION = 'QUOTES_CURRENT_ACTION';
export const QUOTES_RESET_ACTION = 'QUOTES_RESET_ACTION';